import React from 'react';
import { StyledAddToModalContent } from './LeadsDetails.styles';
import Select from '../../molecules/Select';
import Button from '../../molecules/Button';

const AddToModalContent = ({
  label,
  placeholder,
  options,
  selectedValue,
  setSelectedValue,
  loading,
  onCancel,
  onSubmit,
  children,
  showPreview = false,
  previewLoading = false,
  previewData = null,
}) => {
  return (
    <StyledAddToModalContent>
      <Select
        label={label}
        placeholder={placeholder}
        options={options}
        value={options.find(item => item.value?.toString() === selectedValue) || null}
        onChange={e => {
          if (e?.target?.value) {
            setSelectedValue(e.target.value.value?.toString());
          }
        }}
      />

      {children}

      {showPreview && previewLoading && <div className="preview-loading">Loading preview...</div>}

      {showPreview && !previewLoading && previewData && (
        <div className="preview-container">
          <div className="preview-grid">
            <div className="preview-stat">
              <div className="stat-label">Total Leads</div>
              <div className="stat-value total">{previewData.totalLeads || 0}</div>
            </div>
            <div className="preview-stat">
              <div className="stat-label">Duplicate Leads</div>
              <div className="stat-value duplicate">{previewData.duplicateLeads || 0}</div>
            </div>
            <div className="preview-stat">
              <div className="stat-label">Unique Leads</div>
              <div className="stat-value unique">{previewData.uniqueLeads || 0}</div>
            </div>
          </div>
        </div>
      )}

      <div className="button-group">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="darkBlue" disabled={!selectedValue} loader={loading} onClick={onSubmit}>
          Add
        </Button>
      </div>
    </StyledAddToModalContent>
  );
};

export default AddToModalContent;
